import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SezLoaDetailsRequestComponent } from './sez-loa-details-request/sez-loa-details-request.component';
import { SezLoaDetailsApplicationFormComponent } from './sez-loa-details-application-form/sez-loa-details-application-form.component';

@NgModule({
  declarations: [
    SezLoaDetailsRequestComponent,
    SezLoaDetailsApplicationFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class SezLoaDetailsModule { }
